import { Text, TextProps } from '@akin-home/text/native';
import styled from 'styled-components/native';
import { VideoDialogAnchor } from '../videos/components/VideoDialogAnchor';
import { InfoButton } from './InfoButton';

export const ScreenTitle = ({
  source,
  ...props
}: TextProps & { source?: { drive_id: string } }) => (
  <Container>
    <Text variant="h2" weight="semibold" {...props} />

    {source ? (
      <VideoDialogAnchor title={props.children as string} source={source}>
        {(data) => <InfoButton onPress={data.showDialog} />}
      </VideoDialogAnchor>
    ) : null}
  </Container>
);

const Container = styled.View`
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;
